import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';


import { AddExpenseComponent } from './addExpense.component';

import { ExpenseService, SubscribeService } from '../../../services/index';
import * as moment from 'moment';

import { ExpenseModal } from '../../../model/index';

@Component({
    selector: 'cash-in-list',
    templateUrl: './expense.component.html'
})
export class ExpenseComponent implements OnInit {
    isLoadMask: Promise<any>;
    expenseListData: ExpenseModal[];
    //
    loadingIndicator: boolean = true;
    public mode: string;
    page = {
        limit: 25,
        count: 0,
        offset: 0
    };
    
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    //
    columns = [];
    toggleCol = [];
    filterData = {
        "from_date": new Date(),
        "to_date": new Date(),
        "search_data": ""
        
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    constructor(public toasterService: ToasterService, private expenseService: ExpenseService, public subscribeService: SubscribeService) {
        //console.log(this.gs.rootObj);
    }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Expense No', prop: 'expense_no', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'Expense Date', prop: 'expensedate', width: 150, minWidth: 150, maxWidth: 150, toggle: true },
            { name: 'Total Clients', prop: 'total_clients', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Total Amount', prop: 'total_amount', sortable: false, width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-right' },
            { name: 'Action', prop: 'action', width: 240, minWidth: 240, maxWidth: 240, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });
        this.subscribeService.publishReloadExpenseGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getExpenseDateList();
    }

    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getExpenseDateList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    clearFilter(): void {
        this.filterData = {
            "from_date": new Date(),
            "to_date": new Date(),
            "search_data": ""
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getExpenseDateList();
    }
    getExpenseDateList(): void {
        let filterData = {
            ...this.filterData,
            from_date:moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date:moment(this.filterData['to_date']).format('YYYY-MM-DD')
        };
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            // orderColumn: `${this.page.orderBy}`,
            // orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(filterData)
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.expenseService
            .getExpenseList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.expenseListData = res.data;
            });
    }
    addEditExpense(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'expense_id': '',
                mode: mode,
                btnTxt: 'Save'
            };
        } else {
            if (mode == "Edit") {
                row['btnTxt'] = 'Update';
            }
            row['mode'] = mode;
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddExpenseComponent', Object.assign({}, row), this['params']['tabParams']);
    }

    deleteExpense(row: any): void {

        let that = this,
            data = {
                expense_id: row.expense_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Details',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.expenseService
                .deleteExpense(data)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getExpenseDateList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {

        })
    }
    
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/expense/expense.component.ts